import { useTranslation } from "@/i18n/client";
import Input from "@/components/Input";
import { FormInputProps } from "@/types";
import { InputTooltip } from "@/components/InputTooltip";

export const KettleYear = (props: FormInputProps) => {
  const { t } = useTranslation(["supplyPoint", "hints"]);

  return (
    <InputTooltip
      tooltipProps={{
        label: t("hints:supplyPoint.bundleServicesYear"),
      }}>
      <Input label={t("supplyPoint:kettleData.kettleYear")} inputMode="numeric" type="number" {...props} />
    </InputTooltip>
  );
};
